import { createAction, props } from '@ngrx/store';
import { FiltersDto } from '@shared/models/interfaces/filters.interface';

import * as ActionTypes from './activity-tolls-filters.actionTypes';

export const loadTollsFilters = createAction(ActionTypes.LOAD_TOLLS_FILTERS);
export const updateTollsFilters = createAction(ActionTypes.UPDATE_TOLLS_FILTERS, props<{ tollsFilters: FiltersDto }>());
